var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8278DF5F-8C07-49A5-B24D-2EAFB3F77570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-884.000000, -81.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(884.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,12.3248873 L10.7227494,4 L1.11111111,4 C1.04974614,4 1,4.04974614 1,4.11111111 L1,21.8888889 C1,21.9502539 1.04974614,22 1.11111111,22 L18.8888889,22 C18.9502539,22 19,21.9502539 19,21.8888889 L19,12.3248873 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(14.010408, 9.010408) rotate(45.000000) translate(-14.010408, -9.010408) ",
    x: 11.5104076,
    y: 3.01040764,
    width: 5,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(7.828427, 15.192388) rotate(45.000000) translate(-7.828427, -15.192388) ",
    points: "5.32842712 13.6923882 10.3284271 13.6923882 7.80453734 16.6923882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2175144,2.30330086 L21.2175144,2.30330086 C21.7697992,2.30330086 22.2175144,2.75101611 22.2175144,3.30330086 L22.2175144,4.30330086 L17.2175144,4.30330086 L17.2175144,3.30330086 C17.2175144,2.75101611 17.6652297,2.30330086 18.2175144,2.30330086 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(19.717514, 3.303301) rotate(45.000000) translate(-19.717514, -3.303301) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico_edit.8f27128abb6eeabe3d1f68801620e912.svg";
export { ForwardRef as ReactComponent };